import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { CFA_INFO } from '../data/constants';
export function MentionsLegales() {
  return <div className="flex flex-col w-full bg-muted min-h-screen" data-id="element-2105" data-mp="zub007fgoq47">
      <PageHeader title="Mentions Légales" subtitle="Dernière mise à jour : 21/06/2026" data-id="element-2106" data-mp="14s2xdgyvl4fs" />
      <div className="container max-w-4xl mx-auto py-16 md:py-24" data-id="element-2107" data-mp="19kma6bpqnvjj">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl max-w-none" data-id="element-2108" data-mp="1ejgwhnmx028e">
          <p className="text-xl md:text-2xl font-medium text-primary-dark leading-snug mb-8" data-id="element-2109" data-mp="1ik93ea8bdv1i">
            Conformément aux dispositions légales en vigueur, les présentes
            mentions légales ont pour objet d'identifier l'éditeur du site
            internet de Zillenium Alternance et de préciser les conditions
            d'utilisation du site.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2110" data-mp="3pd36uo5andaz">
            1. Éditeur du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2111" data-mp="1bhhwjq4gdloy">
            Le présent site internet, accessible à l'adresse{' '}
            <a href="https://www.zilleniumalternance.fr" className="text-brand-orange hover:underline font-medium" data-id="element-2112" data-mp="11q3qezhzxnmu">
              www.zilleniumalternance.fr
            </a>
            , est édité par :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-2113" data-mp="1ue9b5m91vcmo">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-2114" data-mp="1pgr98ftg9xo6">
              <strong className="font-semibold text-slate-900" data-id="element-2115" data-mp="1ldupgls6bvin">
                {CFA_INFO.legalName}
              </strong>
              <br data-id="element-2116" data-mp="1gdykaj7qpy1i" />
              Exerçant sous l'activité Zillenium Alternance
              <br data-id="element-2117" data-mp="9zh4ppspvw6u" />
              Société par actions simplifiée
              <br data-id="element-2118" data-mp="9wv09z14hwsu" />
              SIRET : {CFA_INFO.siret}
              <br data-id="element-2119" data-mp="4ytirijci5jh" />
              Code NAF : 8559A
              <br data-id="element-2120" data-mp="6h0hfqe6lwvh" />
              UAI : {CFA_INFO.uai}
              <br data-id="element-2121" data-mp="6ibj9ko2gujy" />
              Numéro de déclaration d'activité : {CFA_INFO.nda} auprès du Préfet
              de la Région Bourgogne-Franche-Comté
              <br data-id="element-2122" data-mp="3tlzutmjvomh9" />
              Siège social : {CFA_INFO.address}
              <br data-id="element-2123" data-mp="3tlg87sja99ww" />
              Téléphone : {CFA_INFO.phone}
              <br data-id="element-2124" data-mp="1gvyzutpqs2m" />
              E-mail :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-2125" data-mp="1jrw5gxqlcq0">
                {CFA_INFO.email}
              </a>
            </p>
          </div>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2126" data-mp="39yib8tx4d3cw">
            Zillenium Alternance est un Centre de Formation d'Apprentis et
            organisme de formation. L'enregistrement sous le numéro de
            déclaration d'activité ne vaut pas agrément de l'État.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2127" data-mp="35wexfymz9mog">
            2. Directeur de la publication
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2128" data-mp="2hbsb9dqilkrk">
            Le directeur de la publication est :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-2129" data-mp="2vclbmf3hza2l">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-2130" data-mp="2r8dmwhx1hu4d">
              <strong className="font-semibold text-slate-900" data-id="element-2131" data-mp="358xzuxg9wvpy">
                {CFA_INFO.president}
              </strong>
              <br data-id="element-2132" data-mp="3093d963j6sap" />
              Président de ZILLENIUM SAS
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2133" data-mp="3ezalksztquxo">
            3. Hébergement du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2134" data-mp="3nz60n8wi3a2z">
            Le site{' '}
            <a href="https://www.zilleniumalternance.fr" className="text-brand-orange hover:underline font-medium" data-id="element-2135" data-mp="3j14jitimxku5">
              www.zilleniumalternance.fr
            </a>{' '}
            est hébergé par :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-2136" data-mp="1m8f9coc42h2r">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-2137" data-mp="1r21pwrleb53u">
              <strong className="font-semibold text-slate-900" data-id="element-2138" data-mp="1v1sc0hzz8x21">
                IONOS SARL
              </strong>
              <br data-id="element-2139" data-mp="ydw2ty6vd40u" />
              7 place de la Gare
              <br data-id="element-2140" data-mp="13bns0kg4qc1c" />
              57200 Sarreguemines
              <br data-id="element-2141" data-mp="13c7d2a12tgjl" />
              France
              <br data-id="element-2142" data-mp="17d94i4or4ob0" />
              Site internet :{' '}
              <a href="https://www.ionos.fr" target="_blank" rel="noopener noreferrer" className="text-brand-orange hover:underline font-medium" data-id="element-2143" data-mp="17bpngbv9u986">
                www.ionos.fr
              </a>
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2144" data-mp="2npxyb96oiu3z">
            4. Activité du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2145" data-mp="2sxe99uz1pei9">
            Le site internet de Zillenium Alternance a pour objet de présenter
            l'activité du CFA, ses formations en alternance, ses modalités
            d'admission, ses dispositifs d'accompagnement, ses informations à
            destination des candidats, apprenants, familles, entreprises,
            partenaires et financeurs.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2146" data-mp="2a7y4gvgbuzw1">
            Les informations publiées sur le site sont fournies à titre
            informatif. Zillenium Alternance s'efforce de garantir l'exactitude,
            la mise à jour et la clarté des informations diffusées. Toutefois,
            des erreurs, omissions ou modifications peuvent intervenir.
            L'utilisateur est invité à contacter Zillenium Alternance pour toute
            demande de précision.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2147" data-mp="1sug6uqptpuem">
            5. Propriété intellectuelle
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2148" data-mp="1jxp826jw01gc">
            L'ensemble des éléments présents sur le site, notamment les textes,
            images, visuels, logos, graphismes, documents, contenus
            pédagogiques, vidéos, icônes, éléments de mise en page et structure
            générale du site, sont protégés par le droit de la propriété
            intellectuelle.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2149" data-mp="22ooscugfsn3a">
            Sauf autorisation préalable et écrite de Zillenium Alternance, toute
            reproduction, représentation, modification, adaptation, diffusion,
            exploitation commerciale ou non commerciale, totale ou partielle, du
            contenu du site est interdite.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2150" data-mp="nnonjjbx6njz">
            Toute utilisation non autorisée du site ou de l'un de ses éléments
            pourra engager la responsabilité de son auteur.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2151" data-mp="xl34dk1r9ect">
            6. Responsabilité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2152" data-mp="4z1hoylx5u5c">
            Zillenium Alternance met tout en œuvre pour assurer l'accessibilité
            et le bon fonctionnement du site. Toutefois, l'accès au site peut
            être interrompu temporairement pour des raisons de maintenance, de
            mise à jour, de sécurité, de problème technique ou de force majeure.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2153" data-mp="3ibtpzpcfz0hf">
            Zillenium Alternance ne saurait être tenue responsable des dommages
            directs ou indirects pouvant résulter de l'accès au site, de son
            utilisation, d'une interruption, d'un dysfonctionnement, d'une
            erreur ou d'une impossibilité d'accès.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2154" data-mp="31seruvrbeaq5">
            L'utilisateur reconnaît utiliser le site sous sa seule
            responsabilité.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2155" data-mp="3auwcj5rbmvb1">
            7. Liens hypertextes
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2156" data-mp="3kk7k2nyk7rwt">
            Le site peut contenir des liens vers des sites tiers, partenaires,
            institutions, organismes certificateurs, financeurs, plateformes
            administratives ou ressources externes.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2157" data-mp="2e1jei0bspa5">
            Zillenium Alternance ne peut être tenue responsable du contenu, du
            fonctionnement, de la disponibilité ou des pratiques de ces sites
            tiers. L'accès à ces sites relève de la responsabilité de
            l'utilisateur.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2158" data-mp="1dwgjzkpxri1s">
            Toute création de lien hypertexte vers le site de Zillenium
            Alternance doit faire l'objet d'une autorisation préalable, sauf
            accord ou usage expressément autorisé.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2159" data-mp="21mawg16cf4li">
            8. Données personnelles
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2160" data-mp="1rvyfsk1nfvkn">
            Dans le cadre de l'utilisation du site, Zillenium Alternance peut
            être amenée à collecter et traiter des données personnelles,
            notamment via les formulaires de contact, de demande d'information,
            de candidature ou de mise en relation.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2161" data-mp="1tkg1t8mdbmko">
            Les modalités de traitement des données personnelles sont détaillées
            dans la{' '}
            <a href="/confidentialite" className="text-brand-orange hover:underline font-medium" data-id="element-2162" data-mp="23i40g9n3he84">
              Politique de confidentialité
            </a>{' '}
            disponible sur le site.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2163" data-mp="27ixkut1bwaw9">
            Pour toute question relative aux données personnelles, l'utilisateur
            peut contacter Zillenium Alternance à l'adresse suivante :{' '}
            <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-2164" data-mp="2h8pkw2s75w84">
              {CFA_INFO.rgpdEmail}
            </a>
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2165" data-mp="2r87ze3pc8pss">
            9. Cookies et traceurs
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2166" data-mp="3et8oq5cmtwqk">
            Le site peut utiliser des cookies ou traceurs nécessaires à son
            fonctionnement, à la mesure d'audience, à l'amélioration de
            l'expérience utilisateur ou, le cas échéant, à des finalités de
            communication ou de suivi statistique.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2167" data-mp="2vvfya2j73fa2">
            Lorsque des cookies nécessitent le consentement de l'utilisateur, un
            bandeau d'information et de gestion des préférences est affiché lors
            de la navigation sur le site.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2168" data-mp="285lhj9vr96kj">
            L'utilisateur peut à tout moment modifier ses préférences relatives
            aux cookies selon les modalités prévues sur le site.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2169" data-mp="iozstiqzzs6f">
            10. Contact
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2170" data-mp="9vd0k2m0171z">
            Pour toute question relative au site, à son contenu, aux formations
            ou aux présentes mentions légales, l'utilisateur peut contacter
            Zillenium Alternance :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-2171" data-mp="xlh1g27syspa">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-2172" data-mp="xjmg4msmcyko">
              <strong className="font-semibold text-slate-900" data-id="element-2173" data-mp="skt1gr1lj1ix">
                Zillenium Alternance
              </strong>
              <br data-id="element-2174" data-mp="npdos2fbrbo3" />
              {CFA_INFO.address}
              <br data-id="element-2175" data-mp="3dcv43xuqnrwl" />
              Téléphone : {CFA_INFO.phone}
              <br data-id="element-2176" data-mp="38di8anlw3ahv" />
              E-mail :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-2177" data-mp="38cqp6c9hb58h">
                {CFA_INFO.email}
              </a>
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2178" data-mp="336br80hovhek">
            11. Droit applicable
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2179" data-mp="3czsml8xh54kc">
            Les présentes mentions légales sont soumises au droit français.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2180" data-mp="3lycwbkl243wf">
            En cas de litige relatif à l'utilisation du site, les parties
            s'efforceront de rechercher une solution amiable. À défaut, le
            litige sera soumis aux juridictions françaises compétentes.
          </p>
        </div>
      </div>
    </div>;
}
export function Confidentialite() {
  return <div className="flex flex-col w-full bg-muted min-h-screen" data-id="element-2181" data-mp="21ij4oqtzukl5">
      <PageHeader title="Politique de Confidentialité" subtitle="Dernière mise à jour : 21/06/2026" data-id="element-2182" data-mp="3s0el7yo01yrj" />
      <div className="container max-w-4xl mx-auto py-16 md:py-24" data-id="element-2183" data-mp="3n1uznzdbiozp">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl max-w-none" data-id="element-2184" data-mp="3n3o4ra8a915l">
          <p className="text-xl md:text-2xl font-medium text-primary-dark leading-snug mb-6" data-id="element-2185" data-mp="4uxcd83gsyyw">
            La présente Politique de confidentialité a pour objectif d'informer
            les utilisateurs du site internet de Zillenium Alternance sur la
            manière dont leurs données personnelles peuvent être collectées,
            utilisées, conservées et protégées.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-8" data-id="element-2186" data-mp="3i3te97sf6dl2">
            Zillenium Alternance accorde une importance particulière à la
            protection des données personnelles des candidats, apprenants,
            familles, entreprises, partenaires, financeurs et utilisateurs de
            son site internet.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2187" data-mp="1052cdv4oxmtm">
            1. Responsable du traitement
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2188" data-mp="r447lamfhb9z">
            Le responsable du traitement des données personnelles est :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-2189" data-mp="w3qhba31s9e1">
            <p className="text-sm text-slate-600 leading-relaxed mb-4" data-id="element-2190" data-mp="1ju4d9bor6sdw">
              <strong className="font-semibold text-slate-900" data-id="element-2191" data-mp="1nuwlq2pswt94">
                {CFA_INFO.legalName}
              </strong>
              <br data-id="element-2192" data-mp="19ttyvnqzfex5" />
              Exerçant sous l'activité Zillenium Alternance
              <br data-id="element-2193" data-mp="1esx5vdqivv7r" />
              Centre de Formation d'Apprentis et organisme de formation
              <br data-id="element-2194" data-mp="3ukb7r75mwqe0" />
              SIRET : {CFA_INFO.siret}
              <br data-id="element-2195" data-mp="3umxhndfzzhze" />
              UAI : {CFA_INFO.uai}
              <br data-id="element-2196" data-mp="3fkxcpjtiof9" />
              NDA : {CFA_INFO.nda}
              <br data-id="element-2197" data-mp="3c6w5kmw4l9e" />
              Siège social : {CFA_INFO.address}
              <br data-id="element-2198" data-mp="3fhb8ak11a9l0" />
              Représentée par {CFA_INFO.president}, Président
            </p>
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-2199" data-mp="3bgrbxioab9zx">
              Contact général :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-2200" data-mp="36ny2ihhvfdhi">
                {CFA_INFO.email}
              </a>
              <br data-id="element-2201" data-mp="2wsmmlvuq8086" />
              Contact RGPD :{' '}
              <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-2202" data-mp="2rryzhl9mc3j8">
                {CFA_INFO.rgpdEmail}
              </a>
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2203" data-mp="2itn1gy6fa3gr">
            2. Données personnelles collectées
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2204" data-mp="h0yx2li1l9ze">
            Dans le cadre de son activité, Zillenium Alternance peut être amenée
            à collecter les données personnelles suivantes :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2205" data-mp="y9jd7upyq196">
            <li data-id="element-2206" data-mp="138mdl1uzzjat">
              Données d'identité : nom, prénom, date de naissance, photographie,
              civilité ;
            </li>
            <li data-id="element-2207" data-mp="5lvr2b91n2kf">
              Données de contact : adresse e-mail, numéro de téléphone, adresse
              postale ;
            </li>
            <li data-id="element-2208" data-mp="am1grlvr6ezv">
              Données liées au parcours : niveau scolaire, diplômes, expériences
              professionnelles, CV, lettre de motivation, projet professionnel,
              formation souhaitée ;
            </li>
            <li data-id="element-2209" data-mp="1qyq7ghidw4om">
              Données administratives nécessaires à l'admission ou au suivi :
              pièces justificatives, documents d'inscription, informations liées
              au contrat d'apprentissage, informations transmises par
              l'entreprise ou le financeur ;
            </li>
            <li data-id="element-2210" data-mp="2c2r8bpn0rifp">
              Données relatives à l'entreprise : nom de l'entreprise,
              coordonnées professionnelles, identité du représentant légal,
              maître d'apprentissage, fonction, coordonnées de contact ;
            </li>
            <li data-id="element-2211" data-mp="2lyc61bl21wjn">
              Données de suivi pédagogique : assiduité, évaluations, entretiens,
              bilans, progression, documents de suivi ;
            </li>
            <li data-id="element-2212" data-mp="2urxmczcvblv6">
              Données de navigation : adresse IP, données techniques, cookies,
              préférences de navigation, statistiques de consultation du site ;
            </li>
            <li data-id="element-2213" data-mp="34ry5olaqm1zd">
              Données transmises volontairement par l'utilisateur dans le cadre
              d'un formulaire, d'un e-mail, d'un appel ou d'un échange avec
              Zillenium Alternance.
            </li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2214" data-mp="1af8e4a7ud4v5">
            Zillenium Alternance veille à ne collecter que les données
            nécessaires aux finalités poursuivies.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2215" data-mp="3caflf997id0s">
            3. Finalités des traitements
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2216" data-mp="3h75zjr1gayjk">
            Les données personnelles collectées peuvent être utilisées pour les
            finalités suivantes :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2217" data-mp="37900riaxy8ix">
            <li data-id="element-2218" data-mp="2tdwij1ozxlco">
              Répondre aux demandes d'information envoyées via le site, par
              e-mail ou par téléphone ;
            </li>
            <li data-id="element-2219" data-mp="rl8eiq4j2tvu">Gérer les candidatures et demandes d'admission ;</li>
            <li data-id="element-2220" data-mp="wj1g15uvyzps">
              Analyser l'adéquation entre le profil du candidat, son projet
              professionnel et la formation visée ;
            </li>
            <li data-id="element-2221" data-mp="20250pq6l0rhg">
              Organiser les entretiens, positionnements, réunions d'information
              et rendez-vous ;
            </li>
            <li data-id="element-2222" data-mp="1r3b7m9sgmj8n">
              Accompagner les candidats dans leur recherche d'alternance ;
            </li>
            <li data-id="element-2223" data-mp="1v3ldznk5zbo1">
              Établir, suivre et gérer les dossiers administratifs liés à la
              formation ;
            </li>
            <li data-id="element-2224" data-mp="2iuqrhw2mtrv6">
              Préparer et suivre les contrats d'apprentissage, conventions de
              formation et documents nécessaires ;
            </li>
            <li data-id="element-2225" data-mp="29u2b4uprnff4">
              Assurer le suivi pédagogique, l'assiduité, les évaluations et
              l'accompagnement des apprenants ;
            </li>
            <li data-id="element-2226" data-mp="2eu6x309g12cq">
              Échanger avec les entreprises, maîtres d'apprentissage, OPCO,
              certificateurs, partenaires et autorités compétentes ;
            </li>
            <li data-id="element-2227" data-mp="13ei9q7sa21be">
              Gérer les réclamations, demandes RGPD et démarches qualité ;
            </li>
            <li data-id="element-2228" data-mp="uy9g49ccodcb">
              Améliorer le site internet, les services, la communication et
              l'expérience utilisateur ;
            </li>
            <li data-id="element-2229" data-mp="14umal9fpyv84">
              Respecter les obligations légales, réglementaires,
              administratives, comptables et contractuelles applicables à
              l'activité de CFA et d'organisme de formation.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2230" data-mp="c3m66xdh7pfx">
            4. Bases légales des traitements
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2231" data-mp="lxl23emyiczf">
            Selon les situations, les traitements de données réalisés par
            Zillenium Alternance reposent sur l'une des bases légales suivantes
            :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2232" data-mp="3kma40uviy5m6">
            <li data-id="element-2233" data-mp="1oj5drik5hvdq">
              L'exécution de mesures précontractuelles, notamment pour répondre
              à une demande d'information, étudier une candidature ou préparer
              une admission ;
            </li>
            <li data-id="element-2234" data-mp="1y8oyyuvc61br">
              L'exécution d'un contrat, notamment dans le cadre d'une formation,
              d'un contrat d'apprentissage ou d'une convention de formation ;
            </li>
            <li data-id="element-2235" data-mp="15kt2nr9oibfi">
              Le respect d'obligations légales et réglementaires applicables aux
              CFA, organismes de formation, employeurs, financeurs et
              certificateurs ;
            </li>
            <li data-id="element-2236" data-mp="1eiuzdumdqhwz">
              L'intérêt légitime de Zillenium Alternance, notamment pour assurer
              le suivi des demandes, améliorer ses services, gérer sa
              communication, sécuriser son site et assurer le bon fonctionnement
              de son activité ;
            </li>
            <li data-id="element-2237" data-mp="2uwl6794vvkab">
              Le consentement de la personne concernée, notamment lorsque
              celui-ci est requis pour certains cookies, communications ou
              traitements spécifiques.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2238" data-mp="2vcjlnmdzwwb0">
            5. Destinataires des données
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2239" data-mp="2mbv9yyc2r81a">
            Les données personnelles collectées sont destinées aux services
            internes habilités de Zillenium Alternance.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2240" data-mp="2cd5qj14j5fix">
            Elles peuvent également être transmises, uniquement lorsque cela est
            nécessaire, aux destinataires suivants :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2241" data-mp="alau1squhhla">
            <li data-id="element-2242" data-mp="6lsab0arfck1">
              Entreprises d'accueil ou entreprises partenaires dans le cadre de
              la recherche d'alternance ;
            </li>
            <li data-id="element-2243" data-mp="dm455onlzrur">Maîtres d'apprentissage et tuteurs ;</li>
            <li data-id="element-2244" data-mp="ilp9yfpgmufe">OPCO et organismes financeurs ;</li>
            <li data-id="element-2245" data-mp="4n8zcdoh8jrz">
              Certificateurs, jurys, autorités académiques ou organismes
              habilités ;
            </li>
            <li data-id="element-2246" data-mp="8nsytnwivzha">
              Administrations, autorités de contrôle ou organismes légalement
              compétents ;
            </li>
            <li data-id="element-2247" data-mp="3r0qrd9qzjq1f">
              Prestataires techniques intervenant pour le fonctionnement du
              site, des outils numériques, de l'hébergement, de la maintenance
              ou de la gestion administrative ;
            </li>
            <li data-id="element-2248" data-mp="3m37ead60xjb2">
              Partenaires pédagogiques ou institutionnels lorsque leur
              intervention est nécessaire au parcours de formation.
            </li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2249" data-mp="3d32fgrewbt8i">
            Zillenium Alternance ne vend pas les données personnelles des
            utilisateurs.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2250" data-mp="2tj3lgvieee7f">
            6. Durée de conservation des données
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2251" data-mp="32fm4ng0tunqt">
            Les données personnelles sont conservées pendant une durée limitée,
            déterminée en fonction de la finalité du traitement, de la nature
            des données et des obligations légales applicables. À titre
            indicatif :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2252" data-mp="3m67nqsq3wefi">
            <li data-id="element-2253" data-mp="3h6laijaa2y6p">
              Les données liées aux demandes de contact sont conservées le temps
              nécessaire au traitement de la demande, puis archivées pendant une
              durée raisonnable ;
            </li>
            <li data-id="element-2254" data-mp="3q945yibqi8ix">
              Les données liées aux candidatures non retenues peuvent être
              conservées pendant une durée maximale de 2 ans, sauf opposition de
              la personne concernée ;
            </li>
            <li data-id="element-2255" data-mp="2squ5973k8v4a">
              Les données liées aux apprenants, contrats d'apprentissage,
              conventions, justificatifs de formation, éléments de suivi
              pédagogique, facturation et documents administratifs sont
              conservées pendant la durée nécessaire au suivi du parcours, puis
              selon les obligations légales, réglementaires, comptables,
              contractuelles ou de contrôle applicables ;
            </li>
            <li data-id="element-2256" data-mp="3gjalrd7ngf1h">
              Les données nécessaires à la gestion des réclamations ou demandes
              RGPD sont conservées le temps nécessaire au traitement de la
              demande et à la preuve de sa gestion ;
            </li>
            <li data-id="element-2257" data-mp="1q6d4pkdpjy59">
              Les cookies soumis au consentement sont conservés selon les durées
              prévues par la réglementation applicable et les paramètres définis
              dans l'outil de gestion des cookies.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2258" data-mp="1dukcofrnqe4j">
            7. Sécurité des données
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2259" data-mp="14wqipbhd7wkj">
            Zillenium Alternance met en œuvre des mesures techniques,
            organisationnelles et humaines raisonnables afin de protéger les
            données personnelles contre la perte, l'accès non autorisé, la
            divulgation, l'altération, la destruction ou l'utilisation abusive.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2260" data-mp="1nkvlafmadbhr">
            L'accès aux données est limité aux personnes habilitées, dans la
            limite de leurs missions et responsabilités.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2261" data-mp="c56ybo918cgy">
            Les prestataires susceptibles d'intervenir sur les données
            personnelles sont tenus de respecter des obligations de
            confidentialité, de sécurité et de protection des données.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2262" data-mp="22cejkh5ltexu">
            8. Droits des personnes concernées
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2263" data-mp="2v00xojcgk1yy">
            Conformément à la réglementation applicable en matière de protection
            des données personnelles, toute personne concernée dispose des
            droits suivants :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2264" data-mp="2q80p62ibo0qr">
            <li data-id="element-2265" data-mp="3dy3dq8n12okm">Droit d'accès à ses données personnelles ;</li>
            <li data-id="element-2266" data-mp="3dwk1ct4hsxo4">
              Droit de rectification des données inexactes ou incomplètes ;
            </li>
            <li data-id="element-2267" data-mp="179upyx5t58ta">
              Droit à l'effacement des données, dans les limites prévues par la
              réglementation ;
            </li>
            <li data-id="element-2268" data-mp="12a8dipxszwlj">Droit à la limitation du traitement ;</li>
            <li data-id="element-2269" data-mp="1g26e2cdg8k63">
              Droit d'opposition au traitement, lorsque celui-ci repose sur
              l'intérêt légitime ;
            </li>
            <li data-id="element-2270" data-mp="1c1crpnfnndfb">
              Droit à la portabilité des données, lorsque ce droit est
              applicable ;
            </li>
            <li data-id="element-2271" data-mp="od390udqn5se">
              Droit de retirer son consentement à tout moment, lorsque le
              traitement repose sur le consentement ;
            </li>
            <li data-id="element-2272" data-mp="xcq0oogo0x89">
              Droit de définir des directives relatives au sort de ses données
              après son décès.
            </li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2273" data-mp="28qtu9tjccjcs">
            Pour exercer ces droits, la personne concernée peut contacter
            Zillenium Alternance à l'adresse suivante :{' '}
            <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-2274" data-mp="2if3c3iisq158">
              {CFA_INFO.rgpdEmail}
            </a>
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2275" data-mp="29eyfm3f54n5u">
            La demande devra préciser l'identité du demandeur, l'objet de la
            demande et, si nécessaire, les éléments permettant de l'identifier.
            Une pièce justificative d'identité pourra être demandée uniquement
            en cas de doute raisonnable sur l'identité du demandeur.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2276" data-mp="2sbzldqgiqrau">
            9. Réclamation auprès de la CNIL
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2277" data-mp="3ktbyetv1ecf0">
            Si la personne concernée estime, après avoir contacté Zillenium
            Alternance, que ses droits ne sont pas respectés ou que le
            traitement de ses données personnelles n'est pas conforme à la
            réglementation applicable, elle peut adresser une réclamation à la
            Commission Nationale de l'Informatique et des Libertés, la CNIL.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2278" data-mp="18mqn9nupusf">
            10. Formulaires du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2279" data-mp="a4vs0tve33h7">
            Les formulaires présents sur le site peuvent permettre à
            l'utilisateur de :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-2280" data-mp="jxjo1mejp3ev">
            <li data-id="element-2281" data-mp="ov314iziba58">Demander des informations sur une formation ;</li>
            <li data-id="element-2282" data-mp="tvqtp93dvz1k">Déposer une candidature ;</li>
            <li data-id="element-2283" data-mp="tsuuzijpp6c2">Demander à être recontacté ;</li>
            <li data-id="element-2284" data-mp="xvrj1os0tune">Contacter le CFA ;</li>
            <li data-id="element-2285" data-mp="xwsrrmlke51y">Transmettre une demande en tant qu'entreprise ;</li>
            <li data-id="element-2286" data-mp="2uy8dfp04welk">Signaler une réclamation ou une difficulté.</li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2287" data-mp="2pym0lgo7x0da">
            Les champs obligatoires sont signalés comme tels lorsqu'ils sont
            nécessaires au traitement de la demande. À défaut de renseignement
            des informations obligatoires, Zillenium Alternance pourrait ne pas
            être en mesure de répondre à la demande ou de traiter le dossier.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2288" data-mp="38p3ggknyc1h8">
            11. Cookies et traceurs
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2289" data-mp="3in1353q5xq7q">
            Le site peut utiliser des cookies ou traceurs afin de permettre son
            bon fonctionnement, mesurer son audience, améliorer l'expérience
            utilisateur ou proposer certains contenus intégrés.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2290" data-mp="1e49z843wxiz7">
            Certains cookies sont strictement nécessaires au fonctionnement du
            site et ne nécessitent pas le consentement de l'utilisateur.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2291" data-mp="14eh042kyiwbu">
            Les cookies non essentiels, notamment ceux liés à la mesure
            d'audience avancée, au marketing, aux réseaux sociaux ou aux
            contenus tiers, peuvent nécessiter le consentement préalable de
            l'utilisateur.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2292" data-mp="zdj8z0hyyry7">
            Lors de sa première visite, l'utilisateur peut accepter, refuser ou
            personnaliser ses choix via le bandeau de gestion des cookies,
            lorsque celui-ci est requis.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2293" data-mp="2fuxavilkgosd">
            L'utilisateur peut modifier ses préférences à tout moment depuis le
            module de gestion des cookies disponible sur le site.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2294" data-mp="fs5sjzyp2hl5">
            12. Transferts de données hors Union européenne
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2295" data-mp="6rr44rqfomdf">
            Dans la mesure du possible, Zillenium Alternance privilégie des
            outils et prestataires permettant un hébergement et un traitement
            des données au sein de l'Union européenne.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2296" data-mp="3o7fzbldj4az9">
            Toutefois, certains outils numériques, solutions techniques ou
            prestataires peuvent impliquer un transfert de données en dehors de
            l'Union européenne. Dans ce cas, Zillenium Alternance veille à ce
            que ces transferts soient encadrés par des garanties appropriées
            conformément à la réglementation applicable.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2297" data-mp="1ppmdhfhzs1sn">
            13. Confidentialité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2298" data-mp="1yrvkhve1xd1a">
            Zillenium Alternance s'engage à préserver la confidentialité des
            informations transmises dans le cadre des demandes d'information,
            candidatures, admissions, formations, relations entreprises,
            accompagnements et échanges administratifs.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2299" data-mp="1fzkq6pxgqnes">
            Les données personnelles ne sont accessibles qu'aux personnes ayant
            besoin d'en connaître dans le cadre de leurs missions.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2300" data-mp="navuj6f6faaf">
            14. Modification de la politique de confidentialité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2301" data-mp="1vjkuzru92k6o">
            Zillenium Alternance se réserve le droit de modifier la présente
            Politique de confidentialité à tout moment, notamment afin de tenir
            compte des évolutions légales, réglementaires, techniques,
            organisationnelles ou pédagogiques.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2302" data-mp="1cnl2mfxd1emk">
            La version applicable est celle publiée sur le site à la date de
            consultation.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2303" data-mp="1lnhwqx2ir5p0">
            15. Contact
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2304" data-mp="2x2emyaafw0xy">
            Pour toute question relative à la présente Politique de
            confidentialité ou au traitement des données personnelles,
            l'utilisateur peut contacter :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-2305" data-mp="30j125vysy2mn">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-2306" data-mp="34nh6vtwoj40a">
              <strong className="font-semibold text-slate-900" data-id="element-2307" data-mp="2qmy1kujlmc1t">
                Zillenium Alternance
              </strong>
              <br data-id="element-2308" data-mp="2vm0w3l1yczvj" />
              {CFA_INFO.address}
              <br data-id="element-2309" data-mp="3jb281i9zut5k" />
              E-mail général :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-2310" data-mp="3jbbwv2jayu9o">
                {CFA_INFO.email}
              </a>
              <br data-id="element-2311" data-mp="39kqtz2wlj3ky" />
              E-mail RGPD :{' '}
              <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-2312" data-mp="3ejbtt17xrl8v">
                {CFA_INFO.rgpdEmail}
              </a>
              <br data-id="element-2313" data-mp="aw1z26mg4b7p" />
              Téléphone : {CFA_INFO.phone}
            </p>
          </div>
        </div>
      </div>
    </div>;
}